<form nz-form style="padding-top:12px;padding-right:12px"  autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Nhóm quyền</nz-form-label>
          <asc-autocomplete [ascModel]="groupControl" (ascModelChange)="changeGroup($event)"
            [placeholder]="'Chọn nhóm quyền'" [getListAC]="getGroupACFn"></asc-autocomplete>
        </nz-form-item>
      </div>
  </div>
  <div *nzModalFooter>
      <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="Update()" [disabled]="isDisabled" type="submit">Lưu</button>
  </div>
</form>